module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("\n    $ " + _vm._s(_vm.count) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n    USD\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab52a780"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/Dollar.vue
// module id = 520
// module chunks = 1